import React from "react";
import { isText, isEmail, isCellphone } from "../../utils";
import BunkeyBotUserExists from "./BunkeyBotPublicUserExists";

export const steps = [
  {
    id: "hi",
    message: "¿En qué área de Bunkey crees que te podremos ayudar?",
    trigger: "mainMenu"
  },
  {
    id: "mainMenu",
    options: [
      {
        value: 1,
        label: "Área comercial y Ventas",
        trigger: "commercialAndSales1"
      },
      { value: 2, label: "Soporte", trigger: "support1" },
      { value: 3, label: "Post-venta", trigger: "postVenta1" },
      { value: 4, label: "Otros", trigger: "others1" }
    ]
  },
  {
    id: "commercialAndSales1",
    message:
      "Eduardo se pondrá en contacto contigo. Envianos tu número de celular",
    trigger: "commercialAndSales2"
  },
  {
    id: "commercialAndSales2",
    user: true,
    validator: value => {
      if (!isCellphone(value)) {
        return "Número de celular no válido";
      }
      return true;
    },
    trigger: "commercialAndSales3"
  },
  {
    id: "commercialAndSales3",
    message: "Ahora tu e-mail",
    trigger: "commercialAndSales4"
  },
  {
    id: "commercialAndSales4",
    user: true,
    validator: value => {
      if (!isEmail(value)) {
        return "Email no válido";
      }
      return true;
    },
    trigger: "commercialAndSales5"
  },
  {
    id: "commercialAndSales5",
    message: "Para terminar tu nombre",
    trigger: "commercialAndSales6"
  },
  {
    id: "commercialAndSales6",
    user: true,
    validator: value => {
      if (!isText(value)) {
        return "Nombre no válido";
      }
      return true;
    },
    trigger: "commercialAndSales7"
  },
  {
    id: "commercialAndSales7",
    message: "Gracias te contactaremos a la brevedad",
    end: true
  },
  {
    id: "support1",
    options: [
      {
        value: 5,
        label: "Si tienes problemas para acceder a tu cuenta haz click aquí",
        trigger: "support2"
      },
      {
        value: 6,
        label: "Si tu problema es otro, elige la opción: Otros",
        trigger: "mainMenu"
      }
    ]
  },
  {
    id: "support2",
    message: "Ingresa tu email para revisar si tienes registro en Bunkey",
    trigger: "support3"
  },
  {
    id: "support3",
    user: true,
    validator: value => {
      if (!isEmail(value)) {
        return "Email no válido";
      }
      return true;
    },
    trigger: "support4"
  },
  {
    id: "support4",
    component: <BunkeyBotUserExists />,
    waitAction: true,
    asMessage: true,
    // trigger: 'support5',
    end: true
  },
  {
    id: "postVenta1",
    message:
      "Dame un número de teléfono o e-mail para que Ricardo se ponga en contacto contigo",
    trigger: "postVenta2"
  },
  {
    id: "postVenta2",
    user: true,
    validator: value => {
      if (!isCellphone(value) && !isEmail(value)) {
        return "Número de teléfono o e-mail no válido ";
      }
      return true;
    },
    trigger: "postVenta3"
  },
  {
    id: "postVenta3",
    message: "Gracias te contactaremos a la brevedad",
    end: true
  },
  {
    id: "others1",
    message: "Para comenzar indicame un número de teléfono o e-mail",
    trigger: "others2"
  },
  {
    id: "others2",
    user: true,
    validator: value => {
      if (!isCellphone(value) && !isEmail(value)) {
        return "Número de teléfono o e-mail no válido ";
      }
      return true;
    },
    trigger: "others3"
  },
  {
    id: "others3",
    message: "Cuéntame.... ¿en qué te ayudo?",
    trigger: "others4"
  },
  {
    id: "others4",
    user: true,
    trigger: "others5"
  },
  {
    id: "others5",
    message: "Gracias te contactaremos a la brevedad",
    end: true
  }
];
